






















import {
  Component,
  Emit,
  Inject,
  Model,
  Prop,
  Provide,
  Vue,
  Watch,
  Mixins
} from "vue-property-decorator";
import { ChildMixin } from "@/mixins/multiChildMixin";

@Component({
  components: {}
})
export default class TabBarItem extends Mixins(ChildMixin) {
  @Prop({ default: false })
  private showDot: any;
  @Prop({ default: "" })
  private badge: any;
  @Prop({ default: {} })
  private link: any;
  @Prop({ default: "" })
  private iconClass: any;
  @Prop({ default: "" })
  private labelClass: any;

  private simple: boolean = false;
  private hasActiveIcon: boolean = false;

  get isActive() {
    return (this.$parent as any).index === this.currentIndex;
  }

  public mounted() {
    if (!this.$slots.icon) {
      this.simple = true;
    }
    if (this.$slots["icon-active"]) {
      this.hasActiveIcon = true;
    }
  }
}
